import React from "react";
import { Redirect, Route } from "react-router-dom";
import { getDashboardUser } from "./Storage";

const ProtectedRoutes = ({ component: Component, ...rest }) => {
  const user = getDashboardUser();

  console.log("ProtectedRoutes user:", user);

  return (
    <Route
      {...rest}
      render={(props) => {
        return user ? <Component {...props} /> : <Redirect to="/dashboard" />;
      }}
    ></Route>
  );
};

export default ProtectedRoutes;
